import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthPage from './pages/auth/AuthPage';
import NewDashboard from './pages/dashboard/NewDashboard';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import LeaderboardPage from './pages/leaderboard/LeaderboardPage';
import { OrderBookProvider, PortfolioProvider, SocketProvider } from './app/providers';

function App() {
    return (
        <Router>
            <Routes>
                {/* Admin routes (no socket/provider context needed) */}
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />

                {/* Public leaderboard */}
                <Route path="/leaderboard" element={<LeaderboardPage />} />

                {/* Trader routes */}
                <Route
                    path="/*"
                    element={
                        <SocketProvider>
                            <OrderBookProvider>
                                <PortfolioProvider>
                                    <Routes>
                                        <Route path="/" element={<AuthPage />} />
                                        <Route path="/dashboard" element={<NewDashboard />} />
                                        <Route path="*" element={<Navigate to="/" />} />
                                    </Routes>
                                </PortfolioProvider>
                            </OrderBookProvider>
                        </SocketProvider>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
